
import React, { useEffect, useState } from "react";
import { addDoc, collection, getFirestore, getDocs, getDoc, doc, updateDoc } from "firebase/firestore";
import "../Admin.css";
import Menu from "../Menu/Menu";
import EditArticle from "./EditArticle";
import { useParams } from 'react-router-dom'
import { useUsersContext } from "../../Context/UsersContext";
import LoaderAdmin from "../LoaderAdmin";

export default function EditArticleCont() {
  const { loggedData } = useUsersContext();
  

  const db = getFirestore();
  const [adding, setAdding] = useState(false);
  const [added, setAdded] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const { id } = useParams()
  const [savingDraft, setSavingDraft] = useState(false);
  const [savedDraft, setSavedDraft] = useState(false);



  const save = async (id, newArticle) => {
    setAdding(true);
    try {
      // Asumiendo que 'a' tiene un campo 'id' que corresponde al ID del documento en Firestore
      if (!id) {
        console.error("El artículo no tiene un ID válido");
        setAdding(false);
        return;
      }
        
      // Referencia al documento específico en Firestore
      const articleRef = doc(db, 'articles', id);
  
      // Actualizar el documento existente
      await updateDoc(articleRef, newArticle);
  

      setAdding(false);
      setAdded(true);
  
    } catch (error) {
      console.error("Ocurrió un error durante la actualización:", error);
      setAdding(false);
    }
  };

  const saveDraft = async (a) => {
    setSavingDraft(true);

    try {
      sessionStorage.setItem("articleDraft", JSON.stringify(a));
      const queryCollection = collection(db, `articles`);
      addDoc(queryCollection, a)
        .then((res) => console.log("res"))
        .then(setSavingDraft(false))
        .then(setSavedDraft(true))
        .catch((err) => console.log("err"));
    } catch (error) {
      console.error("Ocurrió un error durante la subida:", error);
      setSavingDraft(false);
    }
  };

  const [articleFetched, setThisArticleFetched] = useState(null);

  const fetchArticleById = async () => {
    setThisArticleFetched(null)
    try {
      const docRef = doc(db, "articles", id); // Reemplaza "collectionName" por el nombre de tu colección
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setThisArticleFetched(docSnap.data());
      } else {
        console.log("No such document!");
        setError("No such document!");
      }


      
    } catch (error) {
      console.error("Error fetching document: ", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    if (id) {
      fetchArticleById(id);
    }
  }, [id]);
 


  


  return (
    <div className="admin-section-cont">
      {loggedData ? 
      <>
       <Menu />
      <div className="w85 position-relative">
        {articleFetched ?         
        
        <EditArticle
          save={save}
          saveDraft={saveDraft}
          savingDraft={savingDraft}
          savedDraft={savedDraft}
          adding={adding}
          added={added}
          articleFetched={articleFetched}
          category={articleFetched.category}
          title={articleFetched.title}
          author={articleFetched.author}
          time={articleFetched.time}
          date={articleFetched.date}
          metaurl={articleFetched.metaurl}
          related={articleFetched.related}
          tags={articleFetched.tags}
          content={articleFetched.body}
          cover={articleFetched.cover}
          position={articleFetched.position}
          subtitle={articleFetched.subtitle}
          enabled={articleFetched.enabled}
          id={id}
        /> : 
        <div  className="w85h100">
                <l-mirage
      size="60"
      speed="2.5" 
      color="black" 
    ></l-mirage>
        </div>
        }

      </div>
      </>
      
      : 
      <LoaderAdmin loggedData={loggedData} />
      }
     
    </div>
  );
}
